import React,{ FC, useEffect } from 'react'
import * as pageUtils from './__index.utils'
import Text from '../../text'

interface redirectProps {
	text: string
	shouldRedirect: boolean
	timeOut?: boolean
	onRedirect: () => void
}

const RedirectModal: FC<redirectProps> = ({
	text,
	shouldRedirect,
	timeOut = true,
	onRedirect
}) => {
	useEffect(() => {
		if (shouldRedirect && timeOut) {
			setTimeout(onRedirect, 3000)
		} else if (shouldRedirect && !timeOut) {
			onRedirect()
		}
	}, [shouldRedirect])

	return (
		timeOut && (
			<div className={pageUtils.classes.container}>
				<Text content={text} />
			</div>
		)
	)
}

export default RedirectModal
